import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

// Screens
import Landing from "./screens/Landing.jsx";
import TrainingDetail from "./screens/FieldDetails.jsx";
import TrainingComponent from "./screens/TrainingComponent.jsx";
import FieldDetailsSearch from "./screens/FieldDetailsSearch.jsx";
import PolitiqueV2 from "./screens/PolitiqueV2.jsx";
import MentionsLegales from "./screens/Mentions_Legales.jsx";

export default function App() {
  return (
    <Router>
      <>
        <Helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="true"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap"
            rel="stylesheet"
          />
        </Helmet>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/formation" element={<TrainingDetail />} />
          <Route path="/formation/:id" element={<FieldDetailsSearch />} />
          <Route path="/politique" element={<PolitiqueV2 />} />
          <Route path="/mentions_legales" element={<MentionsLegales />} />

          <Route path="/formationV2" element={<TrainingComponent />} />
        </Routes>
      </>
    </Router>
  );
}
